import * as React from 'react';

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { logout } from '../store/modules/auth'
import history from '../store/history'
import config from '../helpers/config'

import { Image, Grid, Button } from 'semantic-ui-react';

const Cabecalho = (props) => {
    return (
        <div style={{ position: 'relative' }}>
            <Image src={config.PATH_IMAGEM_1} className='imgLogoCabecalho' />
            {props.auth.authenticated ?
                (<div style={{ position: 'absolute', top: 10, right: 10 }}>
                    <Button content={props.auth.user || 'Alterar email/senha'} icon='edit' labelPosition='right' onClick={() => history.push('/alterarSenha')} />
                    <Button icon='sign out' onClick={() => history.push('/')} />
                </div>) : null}
        </div>
    );
}

const mapStateToProps = state => ({ auth: state.auth, routing: state.routing });
const mapDispatchToProps = dispatch => bindActionCreators({ logout }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Cabecalho);
